export default function normalizeString(str) {
  return str
    .normalize("NFD")                 // decompose accents
    .replace(/[\u0300-\u036f]/g, "")  // remove diacritics
    .toLowerCase();                   // optional: case-insensitive
}